__turbopack_context__.v({
  "className": "twkeverett_2253a465-module__0irMDW__className",
  "variable": "twkeverett_2253a465-module__0irMDW__variable",
});
